import { render, staticRenderFns } from "./improvementTable.vue?vue&type=template&id=3a389714&scoped=true"
import script from "./improvementTable.vue?vue&type=script&lang=js"
export * from "./improvementTable.vue?vue&type=script&lang=js"
import style0 from "./improvementTable.vue?vue&type=style&index=0&id=3a389714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a389714",
  null
  
)

export default component.exports